import React, {Component} from 'react';
import {NavItem} from 'reactstrap';
import {bindActionCreators} from 'redux'
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'

import {logoutUser} from '../../actions/userActions'

class LogoutLink extends Component {
  render() {
    let {login} = this.props.userState
    let {logoutUser} = this.props
    return (
      <NavItem>
            {login.isLogin ? <Link className="nav-link" style={{color:"#000"}} to='/login' onClick={logoutUser}>Déconnexion</Link> : "" }           
      </NavItem>
    )
  }
}


function mapStateToProps({userReducer}) {
  return {
    userState: userReducer
  }
}
function mapDispatchToProps(dispatch) {
  return {
    logoutUser: bindActionCreators(logoutUser, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogoutLink);



// WEBPACK FOOTER //
// ./src/components/user/logoutLink.js